import { createApp } from 'vue';

// Vue 2 replaces the tag where app is mounted, vue 3 doesn't
// Used for VirtualMarketplaceEnquiry.vue
function mountAndReplaceTag(app, selector) {
  const fragment = document.createDocumentFragment();
  const target = document.querySelector(selector);

  app.mount(fragment);
  target.parentNode.replaceChild(fragment, target);
  return app;
}

export const mountApp = (App, selector, plugins = [], beforeMountCallback = null) => {
  let app = createApp(App);

  plugins.forEach(plugin => {
    app.use(plugin);
  });

  if (beforeMountCallback) {
    beforeMountCallback(app);
  }

  app = mountAndReplaceTag(app, selector);

  if (process.env.NODE_ENV === 'production') {
    app.config.errorHandler = (err, vm, info) => {
      console.error(err, vm, info);

      window.Rollbar.error(err, {
        info,
      });
    };
  }

  app.config.devtools = process.env.NODE_ENV !== 'production' || App.debug;
  app.config.performance = process.env.NODE_ENV !== 'production';

  return app;
};
